<template>
  <with-loader :id="id"
               :loading="isLoading"
               class="rounded-lg outline-soft border-soft"
               use-as-overlay
  >
    <t-table :headers="headers"
             :data="tableData"
             :responsive="true"
             variant="selectable"
    >
      <template #thead="{ data, thClass, theadClass, trClass }">
        <thead :class="theadClass">
          <tr :class="trClass">
            <th
              v-for="({ generalClasses, text, columnId }) in data"
              :key="columnId"
              :class="[thClass, generalClasses]"
              class="text-base"
            >
              {{ text }}
            </th>
          </tr>
        </thead>
      </template>

      <template #tbody="{ data, tdClass, trClass, tbodyClass, headers }">
        <tbody :class="tbodyClass">
          <component :is="routeData.length ? 'router-link' : 'tr'"
                     v-for="(row, rowIndex) in data"
                     :id="`selectableRowIndex${rowIndex}`"
                     :to="getRoute(rowIndex)"
                     :key="rowIndex"
                     :class="[trClass, getRowClasses(rowIndex)]"
                     @mouseenter.native="hoverIndex = rowIndex"
                     @mouseleave.native="hoverIndex = null"
                     @click="$emit('click', rowIndex)"
          >
            <slot :headers="headers"
                  :row="row"
                  :row-index="rowIndex"
                  :td-class="tdClass"
                  name="td"
            />
          </component>
        </tbody>
      </template>
    </t-table>
  </with-loader>
</template>

<script>
import WithLoader from '@/components/common/WithLoader'
import isEmpty from 'ramda/src/isEmpty'

export default {
  name: 'SelectableTable',
  components: { WithLoader },
  props: {
    id: {
      type: String,
      default: 'table'
    },
    tableData: {
      type: Array,
      default: () => []
    },
    routeData: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      required: true
    },
    selectedRowIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hoverIndex: null
    }
  },
  methods: {
    getRowClasses(rowIndex) {
      if (rowIndex === this.selectedRowIndex) return 'bg-primary-light text-primary'
      if (rowIndex === this.hoverIndex) return 'hover:bg-primary-light'

      return 'bg-background even:bg-white text-gray-dark'
    },
    getRoute(rowIndex) {
      return isEmpty(this.routeData) ? null : this.routeData[rowIndex]
    },
    getRouteTitle(rowIndex) {
      if (isEmpty(this.routeData)) return null

      const route = this.routeData[rowIndex]
      return this.$router.resolve({ name: route.name, params: route.params }).href
    },
    isSelected(rowIndex) {
      return rowIndex === this.selectedRowIndex
    },
    isHovered(rowIndex) {
      return rowIndex === this.hoverIndex
    }
  },
  async mounted() {
    await this.$nextTick()
    const selectableRow = document.getElementById(`selectableRowIndex${this.selectedRowIndex}`)
    selectableRow?.scrollIntoView(false)
  }
}
</script>

<style scoped>
a:visited {
  color: inherit;
}
</style>
